<fd-form-input-message-group [triggers]="['mouseenter', 'mouseleave']">
  @if (!!label) {
    <app-helpful-label
      [required]="required"
      [for]="id"
      [label]="label"
      [popoverTitle]="popoverTitle"
      [width]="popoverWidth"
      [popoverBody]="popoverDescription ? popoverBody : undefined"
    >
    </app-helpful-label>
  }
  <ng-template #popoverBody>
    @if (!isPopoverDescriptionTemplate) {
      {{ popoverDescription }}
    } @else {
      <ng-container *ngTemplateOutlet="$any(popoverDescription)"></ng-container>
    }
  </ng-template>
  <input
    #input
    fd-form-control
    fdCompact
    type="text"
    [id]="id"
    class="dialog-form-input"
    [(ngModel)]="value"
    (blur)="onBlur()"
    [placeholder]="placeholder"
    [disabled]="ngControl.disabled"
    [state]="Utils.getValidationState(ngControl.control)"
  />
  @if (
    (ngControl.control?.touched || ngControl.control?.dirty) &&
    ngControl.control.errors
  ) {
    <fd-form-message tabindex="-1" type="error">
      {{ customErrorMessage || Utils.validateFormControl(ngControl.control) }}
    </fd-form-message>
  }
</fd-form-input-message-group>
